import { ClientLocal } from "app/api/types";

export const addChatClient = (chats: ClientLocal[], payload: ClientLocal) =>
	[...chats, payload];
